import React from "react";
import SelectOption from "../../../../components/common/Select/Select";
import DateRangePickerNew from "../../../../components/common/DateRangePicker/DateRangePickerNew";
import { addMonths } from "../../../../Utils/utils";
import {
  ReportFilterActions,
  ReportFilterField,
  ReportFilterGrid,
  ReportFilterSearchField,
} from "../../reportFilterUi";

const FeedbackFilters = ({
  selectedStatus,
  selectedParticipant,
  selectedManager,
  fromDate,
  toDate,
  statusOptions,
  participantOptions,
  managerOptions,
  search,
  setSearch,
  onStatusChange,
  onParticipantChange,
  onManagerChange,
  onDateRangeChange,
  onDateCancel,
  loadingParticipants = false,
  loadingManagers = false,
  workersList,
  selectedWorker,
  handleWorkerChange,
  loadingWorkers,
  fetchListReports,
  loader,
  isDisableSearch,
  setReports,
  setFromDate,
  setToDate,
  selectedFromDate,
  setSelectedFromDate,
  setSelectedStatus,
  setSelectedParticipant,
  setSelectedManager,
  setSelectedWorker,
  isUserGracePeriodOver,
  handleFileDownLoad,
  participantLabel = "Participant",
  participantLabelPlural = "Participants",
}) => {
  const handleSearch = () => fetchListReports(false);

  const handleClearFilters = () => {
    setSearch(null);
    setReports([]);
    setFromDate(null);
    setToDate(null);
    setSelectedFromDate(null);
    setSelectedStatus(null);
    setSelectedParticipant(null);
    setSelectedManager(null);
    setSelectedWorker(null);
  };

  return (
    <>
      <ReportFilterGrid columns={4}>
        <ReportFilterField label="Status">
          <SelectOption
            isClearable={true}
            newDesign={true}
            data={statusOptions}
            selectedOption={selectedStatus}
            handleChange={onStatusChange}
            placeHolder="Select Status"
            cssClass="w-full"
          />
        </ReportFilterField>

        <ReportFilterField label={participantLabel}>
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingParticipants}
            cssClass="w-full"
            name="participant"
            isSearch={true}
            data={participantOptions}
            selectedOption={selectedParticipant}
            handleChange={onParticipantChange}
            placeHolder={
              loadingParticipants
                ? `Loading ${participantLabelPlural.toLowerCase()}...`
                : participantOptions.length === 0
                ? `No ${participantLabelPlural.toLowerCase()} available`
                : `Select ${participantLabel}`
            }
            maxHeight="350px"
          />
        </ReportFilterField>

        <ReportFilterField label="Manager">
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingManagers}
            cssClass="w-full"
            name="manager"
            isSearch={true}
            data={managerOptions}
            selectedOption={selectedManager}
            handleChange={onManagerChange}
            placeHolder={
              loadingManagers
                ? "Loading managers..."
                : managerOptions.length === 0
                  ? "No managers available"
                  : "Select Manager"
            }
            maxHeight="350px"
          />
        </ReportFilterField>

        <ReportFilterField label="Worker">
          <SelectOption
            isClearable={true}
            newDesign={true}
            isDisabled={loadingWorkers}
            cssClass="w-full"
            name="worker"
            isSearch={true}
            data={workersList}
            selectedOption={selectedWorker}
            handleChange={handleWorkerChange}
            placeHolder={
              loadingWorkers
                ? "Loading workers..."
                : workersList.length === 0
                  ? "No worker available"
                  : "Select Worker"
            }
            maxHeight="350px"
          />
        </ReportFilterField>

        <ReportFilterField label="Date Range">
          <DateRangePickerNew
            placeholder="Select Date Range"
            showCalendarIcon={true}
            handleCancel={onDateCancel}
            handleChange={onDateRangeChange}
            fromDate={fromDate}
            toDate={toDate}
            setSelectedFromDate={setSelectedFromDate}
            maxDate={addMonths(selectedFromDate, 3)}
          />
        </ReportFilterField>

        <ReportFilterSearchField
          label="Search"
          search={search}
          setSearch={setSearch}
          onSearch={handleSearch}
          placeholder="Search feedback..."
        />
      </ReportFilterGrid>

      <ReportFilterActions
        onSearch={handleSearch}
        onClear={handleClearFilters}
        onExport={handleFileDownLoad}
        isLoading={loader}
        isSearchDisabled={isDisableSearch}
        isUserGracePeriodOver={isUserGracePeriodOver}
      />
    </>
  );
};

export default FeedbackFilters;
